import React from "react";

import { FailureSeverity, ValidationFailure, ValidationResult } from "../../../utils";
import { Icon } from "../../items/Icon";
import { Stack } from "../../layouts/stack/Stack";
import { TooltipHost } from "../../surfaces/tooltip/TooltipHost";

export interface ListItemFailuresIcon {
    result?: ValidationResult;
    isDisabled: boolean;
}

export const ListItemFailures: React.FunctionComponent<ListItemFailuresIcon> = (props: ListItemFailuresIcon) => {
    if (!props.result || props.result.isValid) return <></>;

    const { tooltipContent, hasErrors } = getFailureInfo(props.result.failures);

    return (
        <TooltipHost content={tooltipContent} hidden={props.isDisabled}>
            <Stack verticalAlign="center" horizontalAlign="center" styles={{ root: { height: "100%" } }}>
                <Stack
                    verticalAlign="center"
                    horizontalAlign="center"
                    styles={{
                        root: {
                            height: "100%",
                            background: "#fff4ce",
                            borderRadius: "9px",
                            width: 18,
                            maxHeight: 18,
                            minHeight: 18
                        }
                    }}
                >
                    <Icon
                        disabled={props.isDisabled}
                        iconName={hasErrors ? "ErrorBadge" : "Important"}
                        color={hasErrors ? "#d13438" : undefined}
                        display="inline-block"
                        alignItems="center"
                    />
                </Stack>
            </Stack>
        </TooltipHost>
    );
};

const getFailureInfo = (failures: ValidationFailure[]) => {
    const warnings = failures.filter((f) => f.severity === FailureSeverity.Warning).map((p) => mapFailure(p));

    const errors = failures.filter((f) => f.severity === FailureSeverity.Error).map((p) => mapFailure(p));

    const hasErrors = !!errors.length;

    const tooltipContent = hasErrors ? errors.join(", ") : warnings.join(", ");

    return { tooltipContent, hasErrors };
};

const mapFailure = (failure: ValidationFailure): string => {
    return failure.code ? failure.code + " - " + failure.message : failure.message;
};
